(function() {
    "use strict";

    angular.module("cardspotWeb.areas.hvtRequest")
        .controller("HvtRequest", HvtRequest);

        HvtRequest.$inject = ["$scope", "$rootScope", "$timeout", "SF_EVENTS","notify", "HVT_VIEW_NAMES", "lookupValues", "limitService", "hvtRequestService", "preActivationService", "$location",
            "HVT_REQUEST_TYPES", "$translate"
        ];

    function HvtRequest($scope, $rootScope, $timeout, SF_EVENTS, notify, HVT_VIEW_NAMES, lookupValues, limitService, hvtRequestService, preActivationService, $location,
        HVT_REQUEST_TYPES, $translate) {

        var model = this;
        model.HVT_VIEW_NAMES = HVT_VIEW_NAMES;
        model.activeView = model.HVT_VIEW_NAMES.PROGRAM;
        model.countries;
        model.kycDocumentTypes;
        model.programHvtLimits;
        model.programUniqueTag;
        model.programName;
        model.hvtMinimumLimit;
        model.hvtIndividualSDDLimit;
        model.hvtBankApprovalLimit;
        model.cardMaximumExemptionMinimumLimit;
        model.cardMaximumExemptionMaximumLimit;
        model.merchantGroupCountry;
        model.purchaserInit = purchaserInit;
        model.companyInit = companyInit;
        model.currencyNumericCode;

        model.purchaserInformation = {
            firstName: null,
            lastName: null,
            address1: null,
            address2: null,
            city: null,
            state: null,
            province: null,
            country: null,
            email: null,
            phone: null,
            phoneExt: null,
            postalCode: null,
            birthDate: null,
            kycDocumentType: null,
            kycDocumentId: null,
            kycExpiryDate: null,
            stateRequired: false,
            provinceRequired: false
        };

        model.companyInformation = {
            companyName: null,
            address1: null,
            address2: null,
            city: null,
            state: null,
            province: null,
            country: null,
            tradingName: null,
            taxId: null,
            organizationState: null,
            occupation: null,
            stateRequired: false,
            provinceRequired: false,
            requestType: null,
            naicsCode: null
        }

        model.useOfCards = {
            otherDescription: null,
            selectedOptions: []
        }

        model.transactionInformation = {
            totalTransactionValue: null,
            numberOfCards: null,
            cardAmounts: [{
                quantity: null,
                amount: null,
            }],
            payments: [{
                paymentType: null,
                amount: null,
            }],
            currencyNumericCode: null,
            currencySymbol: null
        }

        model.contactInformation = {
            firstName: null,
            lastName: null,
            emailAddress: null,
            phone: null
        }

        model.viewVisible = function (viewName) {
            return viewName === model.activeView;
        };

        model.changeActiveView = function (view) {
            model.activeView = view;
        };

        $rootScope.$on(SF_EVENTS.PROGRAM_SELECTED, handleProgramSelectedChange);

        $scope.REQUEST_TYPES = HVT_REQUEST_TYPES;
        model.requestType = HVT_REQUEST_TYPES.CONSUMER;

        init();

        function init() {
            model.requestType = $location.path().split('/').pop();
            model.companyInformation.requestType = model.requestType;
            lookupValues.getCountries()
                .then(function (data) {
                    model.countries = data;
                });
            
            lookupValues.getKYCDocumentTypes()
                .then(resp => {
                    model.kycDocumentTypes = resp.data;
                    model.kycDocumentTypes.forEach(dt => {
                        var key = dt.description;
                        dt.displayText = $translate.instant(`DOCUMENT_TYPE.${key}`);
                    })
                });

            model.merchantGroupCountry = preActivationService.getMerchantGroupCountry();
        }

        function purchaserInit() {
            $rootScope.$broadcast(SF_EVENTS.HVT_REQUEST_PURCHASER_STEP_SELECTED);
        }

        function companyInit() {
            $rootScope.$broadcast(SF_EVENTS.HVT_REQUEST_COMPANY_STEP_SELECTED);
        }

        function purchaserInformationComplete() {
            hvtRequestService.addPurchaserInformation(model.purchaserInformation);
            model.changeActiveView(HVT_VIEW_NAMES.COMPANY_INFORMATION);
        }

        $scope.purchaserComplete = function () {
            purchaserInformationComplete();
        };

        function companyInformationComplete() {
            hvtRequestService.addCompanyInformation(model.companyInformation);
            resetUseOfCardsModel();
            model.changeActiveView(HVT_VIEW_NAMES.USE_OF_CARDS);
        }

        $scope.companyComplete = function () {
            companyInformationComplete();
        }

        function useOfCardsComplete() {
            hvtRequestService.addUseOfCards(model.useOfCards);
            var birthDateLocaleString = model.purchaserInformation.birthDate.toLocaleDateString('en-US');
            model.purchaserInformation.birthDate = birthDateLocaleString;
            var expirationDateLocaleString = model.purchaserInformation.kycExpiryDate.toLocaleDateString('en-US');
            model.purchaserInformation.kycExpiryDate = expirationDateLocaleString;
            
            notify.forHttp(hvtRequestService.submitHvtRequest(
                model.programUniqueTag, 
                model.purchaserInformation, 
                model.companyInformation, 
                model.useOfCards, 
                model.transactionInformation,
                model.requestType,
                model.contactInformation), {
                    startTranslationId: "HVT.HVT_REQUEST.FORM.MESSAGES.HVT_REQUEST_SUBMIT_PROGRESS"
                })            
            .then((resp) => {
                if (resp.succeeded) {
                    resetModels();
                    model.changeActiveView(HVT_VIEW_NAMES.PROGRAM);
                    notify.success("HVT.HVT_REQUEST.FORM.MESSAGES.HVT_REQUEST_SUCCESS");
                    $rootScope.$broadcast(SF_EVENTS.HVT_REQUEST_SUCCEEDED);
                } else {
                    notify.showError(resp.message);
                }
            });
        }

        $scope.cardUseComplete = function () {
            useOfCardsComplete();
        }

        function transactionInformationComplete() {
            hvtRequestService.addTransactionInformation(model.transactionInformation);
            model.changeActiveView(HVT_VIEW_NAMES.PURCHASER_INFORMATION);
        }

        $scope.transactionInfoComplete = function () {
            transactionInformationComplete();
        }
        
        function programSelectionComplete() {
            model.changeActiveView(HVT_VIEW_NAMES.TRANSACTION_INFORMATION);
        }

        $scope.programComplete = function() {
            programSelectionComplete();
        }

        function previousStep() {
            switch(model.activeView) {
                case HVT_VIEW_NAMES.TRANSACTION_INFORMATION:
                    model.changeActiveView(HVT_VIEW_NAMES.PROGRAM);
                    break;
                case HVT_VIEW_NAMES.PURCHASER_INFORMATION:
                    model.changeActiveView(HVT_VIEW_NAMES.TRANSACTION_INFORMATION);
                    break;
                case HVT_VIEW_NAMES.COMPANY_INFORMATION:
                    model.changeActiveView(HVT_VIEW_NAMES.PURCHASER_INFORMATION);
                    break;
                case HVT_VIEW_NAMES.USE_OF_CARDS:
                    $rootScope.$emit(SF_EVENTS.HVT_REQUEST_COMPANY_STEP_SELECTED);
                    model.changeActiveView(HVT_VIEW_NAMES.COMPANY_INFORMATION);
                    break;
                default:
                    return;
            }
        }

        $scope.previousStep = function() {
            previousStep();
        }

        function handleProgramSelectedChange(event, program) {
            model.programUniqueTag = program.programUniqueTag;
            model.programName = program.programName;
            model.transactionInformation.cardProgramName = program.programName;
            
            initProgramHvtLimits();
        }

        function handleProgramHvtLimitsResponse(resp) {
            model.programHvtLimits = resp;
            setHvtLimits();
        }

        function initProgramHvtLimits() {
            let programHvtLimits = limitService.getProgramHvtLimits(model.programUniqueTag);

            if (!angular.isArray(programHvtLimits)) {
                limitService.getProgramHvtLimits(model.programUniqueTag)
                .then(function (resp) {
                    handleProgramHvtLimitsResponse(resp);
                    hvtRequestService.getCurrencyByProgram(model.programUniqueTag)
                    .then((resp) => {
                        if (resp.data) {
                            model.currencyNumericCode = resp.data.currencyNumericCode;
                            model.currencySymbol = resp.data.currencySymbol
                            model.transactionInformation.currencyNumericCode = resp.data.currencyNumericCode;
                            model.transactionInformation.currencySymbol = resp.data.currencySymbol;
                        }

                    })
                })
            } else {
                model.programHvtLimits = programHvtLimits;
                setHvtLimits();
            }
        }

        function setHvtLimits() {
            model.hvtMinimumLimit = limitService.getHVTMinimumLimit()?.limit;
            model.hvtIndividualSDDLimit = limitService.getHVTIndividualSDDLimit()?.limit;
            model.hvtBankApprovalLimit = limitService.getHVTBankApprovalLimit()?.limit;
            model.cardMaximumExemptionMinimumLimit = limitService.getCardMaximumExemptionMinimumLimit()?.limit;
            model.cardMaximumExemptionMaximumLimit = limitService.getCardMaximumExemptionMaximumLimit()?.limit;
        }

        function resetModels() {
            resetPurchaserInformationModel();

            resetContactInformationModel();
    
            resetCompanyInformationModel();
    
            resetUseOfCardsModel();
    
            resetTransactionInformationModel();

            model.programUniqueTag = null;
            model.programName = null;

            hvtRequestService.reset();
        }

        function resetContactInformationModel() {
            model.contactInformation = {
                firstName: null,
                lastName: null,
                emailAddress: null,
                phone: null
            }
        }

        function resetTransactionInformationModel() {
            model.transactionInformation = {
                totalTransactionValue: null,
                numberOfCards: null,
                cardAmounts: [{ quantity: null, amount: null }],
                payments: [{ paymentType: null, amount: null }],
                currencyNumericCode: null,
                currencySymbol: null
            }
        }

        function resetPurchaserInformationModel() {
            model.purchaserInformation = {
                firstName: null,
                lastName: null,
                address1: null,
                address2: null,
                city: null,
                state: null,
                province: null,
                country: null,
                email: null,
                phone: null,
                phoneExt: null,
                postalCode: null,
                birthDate: null,
                kycDocumentType: null,
                kycDocumentId: null,
                kycExpiryDate: null
            };
        }

        function resetCompanyInformationModel() {
            model.companyInformation = {
                companyName: null,
                address1: null,
                address2: null,
                city: null,
                state: null,
                province: null,
                country: null,
                tradingName: null,
                taxId: null,
                organizationState: null,
                occupation: null,
                requestType: null,
                naicsCode: null
            }
        }

        function resetUseOfCardsModel() {
            model.useOfCards = {
                otherDescription: null,
                selectedOptions: []
            }
        }
    }

}());
